import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, EffectFade, Autoplay, Mousewheel, Controller, A11y } from 'swiper/modules';
Swiper.use([Navigation, Pagination, Scrollbar, EffectFade, Autoplay, Mousewheel, Controller, A11y]);
import Aos from 'aos'

import "./swiperManager"
import SwiperManager from './swiperManager';

$(() => {
  const FvProgress = document.querySelector('.swiper-fv .autoplay-progress svg')

  if(document.querySelector('.swiper-fv')) {
    new Swiper('.swiper-fv', {
      loop: true,
      effect: 'fade',
      speed: 2000,
      allowTouchMove: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      on: {
        init: function() {
          Aos.refresh()
        },
        autoplayTimeLeft(s, time, progress) {
          FvProgress.style.setProperty("--progress", 1 - progress);
        },
      },
    })
  }

  if(document.querySelector('.swiper-business')) {
    new SwiperManager('.swiper-business', {
      slidesPerView: 2,
      spaceBetween: 40,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      on: {
        init: function() {
          Aos.refresh()
        },
      },
    })
  }

  if(document.querySelector('.swiper-recruit-fv')) {
    new Swiper('.swiper-recruit-fv', {
      slidesPerView: "auto",
      spaceBetween: 20,
      loop: true,
      speed: 11000, // ループの時間
      allowTouchMove: false, // スワイプ無効
      autoplay: {
        delay: 0, // 途切れなくループ
      },
      on: {
        init: function() {
          Aos.refresh()
        },
      },
      breakpoints: {
        768: {
          spaceBetween: 40,
        }
      }
    })
  }

  if(document.querySelector('.swiper-member')) {
    new Swiper('.swiper-member', {
      slidesPerView: "auto",
      spaceBetween: 20,
      loop: true,
      centeredSlides: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      on: {
        init: function() {
          Aos.refresh()
        },
      },
      navigation: {
      },
      breakpoints: {
        768: {
          centeredSlides: false,
          spaceBetween: 40,
        }
      }
    })
  }



  // const RecruitProgressCircle = document.querySelector(".SectionRecruit .AutoplayProgress svg");

  // const swiperRecruit = new Swiper('.swiperRecruit', {
  //   loop: true,
  //   slidesPerView: 1,
  //   spaceBetween: 20,
  //   speed: 500,
  //   autoplay: {
  //     delay: 2500,
  //   },
  //   breakpoints: {
  //     769: {
  //       slidesPerView: 1.5,
  //       spaceBetween: 32,
  //     }
  //   },
  //   on: {
  //     autoplayTimeLeft(s, time, progress) {
  //       RecruitProgressCircle.style.setProperty("--progress", 1 - progress);
  //     },
  //   },
  //   pagination: {
  //     el: '.swiperRecruitPagination',
  //     type: 'fraction',
  //   },
  //   a11y: {
  //     prevSlideMessage: '前のスライドへ',
  //     nextSlideMessage: '次のスライドへ',
  //     slideLabelMessage:'{{index}}枚目のスライド',
  //     paginationBulletMessage: '{{index}}枚目のスライドを表示',
  //   },
  // });



})
